import Logger, {LOG_LEVELS}  from '../utils/log';

export const MODULE_NAME = 'NAVIGATION_MENU_VISIBILITY';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
};

const HIDE_NAVIGATION_MENU = namespaced('HIDE_NAVIGATION_MENU');
const SHOW_NAVIGATION_MENU = namespaced('SHOW_NAVIGATION_MENU');

export const ACTION_TYPES = {
  HIDE_NAVIGATION_MENU,
  SHOW_NAVIGATION_MENU
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {hideNavigationMenu: false}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
      switch (action.type) {
      case HIDE_NAVIGATION_MENU:
          return Object.assign({}, state, {hideNavigationMenu: true});
      case SHOW_NAVIGATION_MENU:
          return Object.assign({}, state, {hideNavigationMenu: false});
      default:
          return state;
      }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
   
  setNavigationMenuVisibility: (hideNavigationMenu) => {
        return (dispatch) => {
            log.debug('setNavigationMenuVisibility()' );
            if(hideNavigationMenu){
              dispatch({type: HIDE_NAVIGATION_MENU});
            }else{
              dispatch({type: SHOW_NAVIGATION_MENU});
            }
           
        };
    }
}

export default API;
